import InputBase from '@material-ui/core/InputBase';
import Grid from '@material-ui/core/Grid';
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import useDebounce from '../../hooks/useDebounce';

const useStyles = makeStyles(() => ({
    textField: {
        width: '260px',
        border: '1px solid #ddd',
        color: '#aaa',
        padding: '5px 20px',
        fontSize: '14px',
        fontWeight: '500',
        backgroundColor: '#fff'
    },
    textFieldWrapper: {
        flexBasis: 'unset'
    }
}));

function FancySearchInputField({ label, value, setValue, placeholder, ...otherProps }) {
    const classes = useStyles();

    const [searchText, setSearchText] = useState(value);
    useEffect(() => {
        setSearchText(value);
    }, [value, setSearchText]);

    useDebounce(() => setValue(searchText), [searchText, setValue], 300);

    return (
        <Grid item container className="golf-options" justifyContent="center">
            <Grid item xs={12} className={classes.textFieldWrapper}>
                <p id="activities-sort-label">{label}</p>
                <InputBase
                    className={classes.textField}
                    placeholder={placeholder}
                    type="text"
                    value={searchText}
                    onChange={ev => setSearchText(ev.target.value)}
                    {...otherProps}
                />
            </Grid>
        </Grid>
    );
}

export default FancySearchInputField;
